
import {defineComponent} from 'vue'
import CheckUtil from "@/commons/utils/CheckUtil";
import ZtnButton from "@/components/input/ztn-button.vue";

export default defineComponent({
  name: "ztn-drawer",
  components: {ZtnButton},
  computed: {
    CheckUtil() {
      return CheckUtil
    }
  },
  emits: ['close', 'edit', 'update:modelValue'],
  props: {
    title: {
      type: String,
      default: null
    },
    drawerInfo: {
      type: Object,
      default: null
    },
    hideEdit: {
      type: Boolean,
      default: false
    },
    viewEditText: {
      type: String,
      default: "Edit"
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit('update:modelValue', false);
      this.$emit('close');
    },
    edit() {
      this.$emit('edit');
    }
  }
})
